import { apiRequest } from '@/http';

// temporary to check if the api request is working
export function initDatabricksApi() {
  if (typeof window !== 'undefined') {
    (window as any).apiRequest = apiRequest;

    console.log('Generic API method available in console:');
    console.log('- window.apiRequest(options)');
    console.log('');
    console.log(' Example usage:');
    console.log('window.apiRequest({');
    console.log('  url: "/gateway/api/me",');
    console.log('  method: "GET"');
    console.log('})');
  }
}
